import { z } from 'zod';
import { otpCodeSchema } from './common';

export const passwordSchema = z
  .string()
  .min(10, 'La password deve avere almeno 10 caratteri')
  .max(200, 'La password è troppo lunga');

export const setupTokenSchema = z.object({ token: z.string().min(16).max(200) });

export const setupStartSchema = z.object({
  token: z.string().min(16).max(200),
  name: z.string().trim().min(1, 'Scrivi il tuo nome').max(80),
  email: z.email('Email non valida').max(200),
  password: passwordSchema,
});
export type SetupStartInput = z.infer<typeof setupStartSchema>;

export const setupFinishSchema = z.object({
  token: z.string().min(16).max(200),
  code: otpCodeSchema,
  remember: z.boolean().default(true),
});
export type SetupFinishInput = z.infer<typeof setupFinishSchema>;

export const loginSchema = z.object({
  email: z.email('Email non valida').max(200),
  password: z.string().min(1, 'Scrivi la password').max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const loginCodeSchema = z.object({
  ticket: z.string().min(16).max(200),
  code: otpCodeSchema,
  remember: z.boolean().default(false),
});
export type LoginCodeInput = z.infer<typeof loginCodeSchema>;

export const reauthSchema = z
  .object({
    code: otpCodeSchema.optional(),
    password: z.string().max(200).optional(),
  })
  .refine((v) => Boolean(v.code || v.password), { message: 'Serve il codice o la password' });
export type ReauthInput = z.infer<typeof reauthSchema>;

export interface Me {
  id: string;
  name: string;
  email: string;
  totpEnabled: boolean;
  /** Fino a quando vale la ri-conferma (ISO), null se non attiva. */
  reauthUntil: string | null;
}

export interface AuthState {
  needsSetup: boolean;
  user: Me | null;
}

export interface SetupTokenInfo {
  valid: boolean;
  purpose: 'setup' | 'reset' | null;
  email: string | null;
}

export interface SetupStartResult {
  /** Segreto TOTP in base32, da scrivere a mano se il QR non si legge. */
  secret: string;
  otpauthUrl: string;
  /** QR code come data URL PNG. */
  qrDataUrl: string;
}

export interface LoginTicket {
  ticket: string;
}

export interface ReauthResult {
  reauthUntil: string;
}
